export function registerServiceWorker() {
  if (import.meta.env.DEV) {
    unregisterServiceWorker();
    return;
  }

  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      });

      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          registration.update();
          if (import.meta.env.DEV) {
            console.log('SW registered:', registration.scope);
          }
        })
        .catch((error) => {
          if (import.meta.env.DEV) {
            console.error('SW registration failed:', error);
          }
        });
    });
  }
}

export function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });

    if ('caches' in window) {
      caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName);
        });
      });
    }
  }
}
